export const selectDialogs = ({ dialogs }) => dialogs;
